import { useGetOpsRunQuery, useGetOpsRunsQuery } from "../store/api/mlbApi";

export const useOpsRuns = (filters = {}) => {
  const { data, error, isLoading, refetch } = useGetOpsRunsQuery(filters);
  return {
    runs: data?.runs || [],
    total: data?.total || 0,
    page: data?.page || 1,
    pageSize: data?.pageSize || 25,
    error: error?.data?.error || error?.message,
    isLoading,
    refetch,
    isAdminError: error?.data?.code === "ADMIN_REQUIRED",
  };
};

export const useOpsRun = (id) => {
  const { data, error, isLoading } = useGetOpsRunQuery(id, { skip: !id });
  return {
    run: data?.run || null,
    error: error?.data?.error || error?.message,
    isLoading,
  };
};
